import { previewAttachmentInPopOut } from 'owa-attachment-deeplink-popout';
import { previewAttachment } from 'owa-attachment-select-actions/lib/actions/publicActions';
import { orchestrator } from 'satcheljs';
import getCurrentModule from 'owa-app-module/lib/selectors/getCurrentModule';
import { Module } from 'owa-bootstrap';

orchestrator(previewAttachment, actionMessage => {
    const currentModule = getCurrentModule();
    if (
        currentModule &&
        currentModule !== Module.Mail &&
        currentModule !== Module.FilesHub &&
        currentModule !== Module.MailDeepLink
    ) {
        const { context } = actionMessage;

        previewAttachmentInPopOut(
            context.parentItemId,
            context.viewState.attachmentId.Id,
            false /* isEdit */
        );
    }
});
